var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12","sm":"4"}},[_c('proccessed-list-item-component',{attrs:{"item":item},on:{"close":function($event){return _vm.$emit('close')}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }